import type { WorkflowOptions } from '../../types';
import { addFulfillmentContextLinkPropertiesWorkflow } from './addFulfillmentContextLinkPropertiesWorkflow';
import { deactivateFulfillmentContextLinkPropertiesWorkflow } from './deactivateFulfillmentContextLinkProperties';

export const workflows: WorkflowOptions[] = [
  addFulfillmentContextLinkPropertiesWorkflow,
  deactivateFulfillmentContextLinkPropertiesWorkflow,
];

export default workflows;
